
















































import { useStatusBoardCharacterModule } from '@/modules/statusBoard/character';
import { StatusBoardStoreModule, StatusBoardStoreModuleKey } from '@/modules/statusBoard/store';
import { useStatusBoardTemplateModule } from '@/modules/statusBoard/template';
import { Character, CharacterPart } from '@/types/statusBoard';
import { defineComponent, reactive, SetupContext, PropType, inject, watch } from '@vue/composition-api';

export default defineComponent({

  props: {
    value: { type: Boolean as PropType<boolean>, required: true },
    character: { type: Object as PropType<Character>, required: true }
  },

  setup (props, ctx: SetupContext) {

    const { room } = inject(StatusBoardStoreModuleKey) as StatusBoardStoreModule;
    const characterModule = useStatusBoardCharacterModule();
    const template = useStatusBoardTemplateModule();

    const localState = reactive({
      character: characterModule.copyCharacter(props.character)
    });

    watch(() => props.value, showDialog => {
      if (!showDialog) return;
      localState.character = characterModule.copyCharacter(props.character);
    });

    function input (value: boolean): void {
      ctx.emit('input', value);
    }

    function done (): void {
      ctx.emit('done', localState.character);
      input(false);
    }

    function add (): void {
      localState.character.parts.push(template.createPart(room.value.template));
    }

    function remove (id: string): void {
      localState.character.parts = localState.character.parts.filter(p => p.id !== id)
    }

    return {
      localState,
      input,
      done,
      add,
      remove
    }
  }
});
